import gql from 'graphql-tag';
import { tagGQLFields } from './tag.fields.js';
export function getTagsGQLQuery(fields) {
    return gql `
    query GetTags(
      $spaceId: ID
      $limit: Int!
      $orderBy: TagListOrderByEnum
      $reverse: Boolean
      $query: String
    ) {
      tags(
        spaceId: $spaceId
        limit: $limit
        orderBy: $orderBy
        reverse: $reverse
        query: $query
      ) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            ${tagGQLFields(fields)}
          }
        }
        nodes {
          ${tagGQLFields(fields)}
        }
      }
    }
  `;
}
export const createTagGQLMutation = (fields) => gql `
  mutation CreateTag($spaceId: ID!, $input: CreateTagInput!) {
    createTag(spaceId: $spaceId, input: $input) {
      ${tagGQLFields(fields)}
    }
  }
`;
export const updateTagGQLMutation = (fields) => gql `
  mutation UpdateTag($id: ID!, $spaceId: ID!, $input: UpdateTagInput!) {
    updateTag(id: $id, spaceId: $spaceId, input: $input) {
      ${tagGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=tags.gql.js.map